<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="所属学员" prop="student_id">
        <v-select-student
          class="w100"
          v-model="post.student_id"
          :is-get-is-used-card-invalid="true"
          @change="handleStudentChange"
        />
        <router-link v-if="post.student_id" :to="RouteConfig.studentDetail.to(post.student_id)" class="primary-color">
          查看学员主页
        </router-link>
      </el-form-item>

      <el-form-item v-if="post.student_id" label="可用积分">
        <span class="integral-box">
          <template v-if="student.integral">
            <b class="primary-color integral">{{ student.integral | toYuan }}</b> 分
          </template>
          <span v-else class="info-color">暂无可用积分</span>
        </span>
      </el-form-item>

      <el-form-item v-if="student.integral" label="使用积分" prop="payment_remark">
        <v-input-money
          placeholder="请输入购买课卡所用的积分"
          v-model="post.integral"
          :is-show-suffix="true"
          suffix-name="分"
          :min="0"
          :max="student.integral | toYuan"
        />
      </el-form-item>

      <el-form-item label="课次券类型" prop="card_ticket_type_id">
        <v-select-card-ticket-type
          class="w100"
          v-model="post.card_ticket_type_id"
          @change="handleCardTicketTypeChange"
        />
        <el-alert
          v-if="student.id && !student.is_new && cardTicketType.is_new"
          title="该课次券仅限新生办理，请选择其他课次券"
          type="error"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <template v-if="cardTicketType.id">
        <el-form-item label="有效次数" prop="expire_number">
          <span class="primary-color">{{ cardTicketType.expire_number }}</span> 次
        </el-form-item>

        <el-form-item label="有效天数" prop="expire_days">
          <span class="primary-color">{{ cardTicketType.expire_days }}</span> 天
        </el-form-item>

        <template v-if="cardTicketType.card_charge_type_id">
          <el-form-item label="需绑定的课卡类型" prop="expire_days">
            <span class="primary-color">{{ cardTicketType.card_name }}</span>
          </el-form-item>

          <el-form-item label="开卡时不自动开券">
            <el-switch v-model="cardTicketType.is_not_auto_start" :disabled="true" :active-value="1" :inactive-value="0"/>

            <el-alert
              v-if="cardTicketType.is_not_auto_start"
              title="本课次券将在初次签到课程时开券，但已绑定的课卡次数用尽后才会生效，未生效时无法进行预约并开券。"
              type="warning"
              show-icon
              :closable="false"
            />
            <el-alert
              v-else
              title="本课次券将在已绑定的课卡开卡时自动开券，课次券有效期将与课卡保持一致，但课卡次数用尽后才会生效，即已开券但未生效仍无法使用。"
              type="info"
              show-icon
              :closable="false"
            />

          </el-form-item>
        </template>

      </template>

      <el-form-item v-if="cardTicketType.card_charge_type_id" label="绑定课卡" prop="card_id">
        <v-select-card-list
          class="w100"
          :student-id="post.student_id"
          :card-charge-type-id="cardTicketType.card_charge_type_id"
          :card-ticket-type-id="cardTicketType.id"
          v-model="post.card_id"
          @listLengthChange="e => isCardListEmpty = !e"
          @change="e => cardTicketType.is_not_auto_start ? 1 : cardTicketType.expire_days = e.expire_days"
        />
        <el-alert
          v-if="isCardListEmpty"
          :title="`学员名下暂无「${cardTicketType.card_name}」，无法进行绑定`"
          type="error"
          show-icon
          :closable="false"
        />
        <el-alert
          v-else-if="!post.card_id"
          title="本课次券需要与课卡进行绑定，系统只展示学员名下可绑定的课卡"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="实际付款">
        <v-input-money
          class="w100"
          v-model="post.actual_payment"
          placeholder="请输入购券的实际付款（去除优惠金额）"
          :is-show-suffix="true"
        />
        <el-alert
          v-if="post.integral > 0"
          :title="`积分抵扣 ${post.integral} 元`"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <template v-if="post.actual_payment > 0">
        <el-form-item label="收款方式" prop="card_payment_mode_id">
          <v-select-card-payment-mode class="w100" v-model="post.card_payment_mode_id" placeholder="请输入办理课次券的收款方式"/>
        </el-form-item>

        <v-image-upload
          v-model="post.receipt"
          label="付款凭证"
          prefix="card-ticket"
          placeholder="请上传例如微信转账截图、支付宝转账截图等"
          propName="receipt"
        />

        <v-input-you-zan-number
          v-model="post.you_zan_number"
          :card-payment-mode-id="post.card_payment_mode_id"
          @actualPaymentChange="actual_payment => post.actual_payment = post.you_zan_payment = actual_payment"
        />

        <el-form-item v-if="post.card_payment_mode_id === cardPaymentModeIds.youZan" label="有赞核销金额">
          <v-input-money
            class="w100"
            v-model="post.you_zan_payment"
            placeholder="请输入购买有赞的核销金额"
            :is-show-suffix="true"
          />
        </el-form-item>
      </template>

      <el-form-item label="付款备注" prop="payment_remark">
        <el-input v-model="post.payment_remark" placeholder="请输入课卡付款备注"/>
      </el-form-item>

      <v-image-upload v-model="post.remark_file" label="备注文件" prefix="card"/>

      <el-form-item v-if="!cardTicketType.card_charge_type_id" label="申请原因" prop="apply_remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入 2 个字符以上的申请原因"
          v-model="post.apply_remark"
          maxlength="200"
          show-word-limit
        />
        <el-alert
          title="办理此课次券时需要填写办券原因并提交申请，审核通过后即可成功办理"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.cardTicketList.back">取消</el-button>
      </el-form-item>

    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import cardPaymentModeIds from '@/enums/cardPaymentModeIds';
import { mapGetters } from 'vuex';
import { pickerOptionsBetweenSystemStartAndToday, pickerOptionsOfAfterToday } from '@/utils/formats';
import { store } from '@/api/card-ticket';
import { checkIsNew } from '@/api/student';
import { store as storeApply } from '@/api/card-ticket-add-apply';
import { minus, toCent, toYuan } from '@/filters';

export default {
  name: RouteConfig.cardTicketAdd.name,
  data: () => ({
    RouteConfig,
    cardPaymentModeIds,
    pickerOptionsBetweenSystemStartAndToday,
    pickerOptionsOfAfterToday,
    isSaving: false,
    isCardListEmpty: false,
    cardNumber: '',
    integral: 0,
    student: {
      id: 0,
      is_new: 0,
      integral: 0,
    },
    isUsedCardInvalid: false,
    cardTicketType: {
      id: 0,
      update_time: 0,
      card_ticket_type_name: '',
      expire_number: 0,
      expire_days: 0,
      price: 0,
      actual_payment: 0,
      is_new: 0,
      is_not_auto_start: 0,
      card_charge_type_id: 0,
      card_name: '',
    },
    post: {
      student_id: 0,
      card_id: 0,
      card_ticket_type_id: 0,
      update_time: 0,
      expire_number: '',
      expire_days: '',
      card_payment_mode_id: '',
      you_zan_number: '',
      actual_payment: '',
      you_zan_payment: '',
      payment_remark: '',
      receipt: '',
      remark_file: '',
      integral: '',
      apply_remark: '',
    },
    students: [],
    rules: {
      student_id: [{ required: true, message: '请选择所属学员', trigger: 'change' }],
      card_payment_mode_id: [{ required: true, message: '请选择付款方式', trigger: 'change' }],
      card_ticket_type_id: [{ required: true, message: '请选择课次券类型', trigger: 'change' }],
      you_zan_number: [{ required: true, message: '请输入有赞券码', trigger: 'change' }],
      actual_payment: [{ required: true, message: '请输入实付金额', trigger: 'change' }],
      receipt: [{ required: true, message: '请上传付款凭证图片', trigger: 'change' }],
      apply_remark: [{ required: true, message: '请输入申请原因', trigger: 'change' }],
    },
  }),
  watch: {
    'post.integral'(integral) {
      if (integral < 0) return;
      this.computeActualPayment(integral);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isGenericStore',
      'userStoreId',
    ]),
  },
  methods: {
    toYuan,
    computeActualPayment(integral) {
      if (!this.cardTicketType.id) return;

      const actualPayment = minus(this.cardTicketType.price, integral);
      if (actualPayment > 0) {
        this.post.actual_payment = actualPayment;
      } else {
        this.post.actual_payment = 0;
        this.post.integral = this.cardTicketType.price;
      }
    },
    async handleStudentChange(student) {
      const { isError, data } = await checkIsNew(student.id);
      this.student = {
        id: student.id,
        integral: student.integral,
        is_new: !isError && data ? !!data.is_new : false,
      };
      this.post.card_id = 0;
    },
    handleCardTicketTypeChange(cardTicketType) {
      const price = toYuan(cardTicketType.price);

      this.cardTicketType = {
        id: cardTicketType.id,
        update_time: cardTicketType.update_time,
        card_ticket_type_name: cardTicketType.card_ticket_type_name,
        expire_number: toYuan(cardTicketType.expire_number),
        expire_days: toYuan(cardTicketType.expire_days),
        price,
        actual_payment: price,
        is_new: cardTicketType.is_new,
        is_not_auto_start: cardTicketType.is_not_auto_start,
        card_charge_type_id: cardTicketType.card_charge_type_id,
        card_name: cardTicketType.card_name,
      }

      this.post.update_time = cardTicketType.update_time || 0;
      this.computeActualPayment(this.post.integral);
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const post = { ...this.post };

        post.actual_payment = toCent(post.actual_payment);
        post.you_zan_payment = toCent(post.you_zan_payment);
        post.integral = toCent(post.integral);

        const submitFn = this.cardTicketType.card_charge_type_id ? store : storeApply;
        const { isError } = await submitFn(post);
        this.isSaving = false;
        if (!isError) this.cardTicketType.card_charge_type_id ? RouteConfig.cardTicketList.push() : RouteConfig.cardTicketAddApplyList.push();
      });
    },
  },
};
</script>

<style scoped>
  .integral-box {
    padding-left: 10px;
    font-size: 16px;
  }

  .integral {
    font-size: 18px;
  }
</style>
